import { render, staticRenderFns } from "./RelatoriosOsV2.vue?vue&type=template&id=eb763f56&scoped=true&"
import script from "./RelatoriosOsV2.vue?vue&type=script&lang=js&"
export * from "./RelatoriosOsV2.vue?vue&type=script&lang=js&"
import style0 from "./RelatoriosOsV2.vue?vue&type=style&index=0&id=eb763f56&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb763f56",
  null
  
)

export default component.exports